import { MaskText, Reveal } from "./Reveal";

const CHAPTERS = [
  {
    no: "01",
    tag: "Belief",
    lines: ["Design isn't", "decoration. It's", "the intersect of", "function and beauty."],
    body: "Pretty is easy. We're after work that carries weight — that earns attention and holds up under pressure. Every choice does a job.",
  },
  {
    no: "02",
    tag: "Approach",
    lines: ["Ideas need more", "than a good story —", "they need visual", "storytelling."],
    body: "People want to feel something when they look at your brand. Strategy points the way, but design is what makes it land — turning the story into something people can see, remember, and be a part of.",
  },
  {
    no: "03",
    tag: "The Difference",
    lines: ["Run by someone", "who's been in", "your shoes."],
    body: "Founder, dreamer, thinker — before ever picking up a client brief. We speak builder-to-builder, like a peer, not a vendor.",
  },
];

const Manifesto = () => {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative bg-[#f7f3ea] py-28 md:py-44"
    >
      <div className="px-6 md:px-12 lg:px-16">
        <Reveal className="mb-20 md:mb-32 flex items-center gap-4">
          <span className="label text-[#0a0a0a]/40">(What we believe)</span>
          <span className="h-px flex-1 bg-black/10" />
        </Reveal>

        <div className="flex flex-col gap-24 md:gap-40">
          {CHAPTERS.map((c, i) => (
            <div
              key={c.no}
              data-testid={`manifesto-chapter-${i + 1}`}
              className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10"
            >
              <div className="md:col-span-4">
                <div className="md:sticky md:top-28">
                  <div className="flex items-baseline gap-3">
                    <span className="outline-text text-[#0a0a0a] text-8xl md:text-[9rem] font-extrabold tight leading-none">
                      {c.no}
                    </span>
                    <span className="text-xs font-semibold text-[#0a0a0a]/35 tabular-nums tracking-widest">
                      /03
                    </span>
                  </div>
                  <p className="label mt-5 flex items-center gap-2 text-[#0a0a0a]/50">
                    <span className="inline-block h-px w-6 bg-[#0a0a0a]/40" />
                    {c.tag}
                  </p>
                </div>
              </div>
              <div className="md:col-span-8 md:pl-6">
                <MaskText
                  lines={c.lines}
                  className="tight font-extrabold text-[#0a0a0a] text-[7.5vw] md:text-[5.4vw] mb-8"
                />
                <Reveal delay={0.15}>
                  <p className="max-w-xl text-lg md:text-xl leading-relaxed text-[#0a0a0a]/70 font-medium">
                    {c.body}
                  </p>
                </Reveal>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
